import { lazy } from 'react'

// Reload the page when a lazy chunk 404s after a new deployment so the browser
// fetches fresh HTML with the updated asset hashes.
export function lazyWithReload(fn) {
  return lazy(() => fn().catch(() => {
    const key  = 'chunk_reload_at'
    const last = parseInt(sessionStorage.getItem(key) ?? '0', 10)
    const now  = Date.now()
    if (now - last < 10_000) {
      sessionStorage.removeItem(key)
      window.location.href = '/'
      return new Promise(() => {})
    }
    sessionStorage.setItem(key, String(now))
    window.location.reload()
    return new Promise(() => {})
  }))
}
